'use client';

import { classes } from '@/uiPrimitives/base/classes.helpers';
import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import { textBlock } from '@/uiPrimitives/typography/text';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { closeIcon } from '@/uiIcons/closeIcon.css';
import { icon } from '@/uiPrimitives/media/icon';
import { useFocusOnMount } from '@dop/shared/hooks/useFocusOnMount';
import { ElementRef } from 'react';
import { callToActionBox } from '@/uiComposites/interactive/callToAction';
import { WebAPITransactionBlock } from '@/globals/webApiTypes/elements/WebAPITransactionBlock';
import { translateInline } from '@/globals/translate/translateInline';

export const SelectedRegion = ({
	transactionBlock,
}: {
	transactionBlock: WebAPITransactionBlock;
}) => {
	const closeBtnRef = useFocusOnMount<ElementRef<'a'>>();

	return (
		<DOPLink
			ref={closeBtnRef}
			aria-label={translateInline({
				en: 'Choose a different municipality, province or water authority',
				nl: 'Kies een andere gemeente, provincie of waterschap',
			})}
			href={transactionBlock.filter.baseUrl}
			data-link-type="transactionBlockResetChosenRegionButton"
			className={classes(callToActionBox({}), shelf({ columnGap: '0 | p' }))}
		>
			<span className={classes(textBlock({}))}>
				{transactionBlock.transactionResults?.name}
			</span>
			<i
				className={classes(
					icon({
						icon: closeIcon,
						inlineSize: '-1 | small',
						blockSize: '-1 | small',
					}),
				)}
			/>
		</DOPLink>
	);
};
